import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useFeaturedFilter } from './useFeaturedFilter';

export const FeaturedFilter = ({ value, setFilters, featuredOptions }) => {
  const { formSchema, onSubmit } = useFeaturedFilter({ setFilters });

  const selectedOption = featuredOptions.find((i) => i.value === value) ?? featuredOptions[0];

  return (
    <Formik
      initialValues={{ featured: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="featured"
          label="Featured"
          placeholder="Featured"
          size="small"
          component={FormSelect}
          options={featuredOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

FeaturedFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  featuredOptions: PropTypes.array.isRequired,
};

FeaturedFilter.defaultProps = {
  value: '',
};
